import Offers from './Offers';
import { useOffersUK } from '../../hooks/useOffers/useOffersUK';
import ApplicationLoader from '../ApplicationLoader/ApplicationLoader';
import OffersCheck from '../OffersCheck/OffersCheck';

const OffersWithOffersCheck = () => {
  const offersInformation = useOffersUK({ enabled: true });

  return (
    <OffersCheck {...offersInformation}>
      {!offersInformation.offers ? (
        <ApplicationLoader />
      ) : (
        <Offers offers={offersInformation.offers} />
      )}
    </OffersCheck>
  );
};

export default OffersWithOffersCheck;
